import { type InputHTMLAttributes, type ReactNode, forwardRef } from 'react'

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode
  /** Override delle classi testo/spaziatura della label, per contesti con una palette diversa (es. pagina di login). */
  labelClassName?: string
}

/** Checkbox custom: l'input nativo resta nel DOM (accessibilità, register() di react-hook-form)
 * ma è reso invisibile via appearance-none - il quadratino disegnato è il nostro, non quello del browser/OS. */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, labelClassName, className = '', id, ...rest },
  ref
) {
  return (
    <label htmlFor={id} className={labelClassName ?? 'flex w-fit cursor-pointer items-center gap-2 text-sm text-body select-none'}>
      <span className="relative inline-flex h-4 w-4 shrink-0 items-center justify-center">
        <input
          type="checkbox"
          id={id}
          ref={ref}
          className={`da-checkbox peer h-4 w-4 shrink-0 appearance-none rounded border border-border-strong bg-canvas checked:border-primary-600 checked:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500/40 ${className}`}
          {...rest}
        />
        <svg
          className="pointer-events-none absolute h-3 w-3 text-on-dark opacity-0 peer-checked:opacity-100"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 13l4 4L19 7" />
        </svg>
      </span>
      {label}
    </label>
  )
})
